import { CSSProperties } from '@mui/material';
import { PrimaryColors } from '@/common/theme/constants';

export const hyperlinkStyles: CSSProperties = {
  background: 'transparent',
  color: PrimaryColors.white,
  textDecoration: 'underline',
};
